module.exports = require("./ru-KG");